import matrix from '../matrix'
import legendMatrix from '../legend-matrix'

import {
  arrMatrix1, arrMatrix2, arrMatrix3, arrPopup1, arrPopup2, arrPopup3, arrPopup4, arrPopup5,
  task1, task2, task3, task4, task5,
} from './arr'

export default {
  components: {
    matrix, legendMatrix,
  },
  setup() {
    const arrMatrixFull = [arrMatrix1, arrMatrix2, arrMatrix3]
    const arrMatrixRandom = arrMatrixFull[Math.floor(Math.random() * arrMatrixFull.length)]
    return {
      arrMatrix: arrMatrixRandom,
      arrPopup1,
      arrPopup2,
      arrPopup3,
      arrPopup4,
      arrPopup5,

      task1,
      task2,
      task3,
      task4,
      task5,
    }
  },
}
